<template>
  <product-base-modal
    :loading="loading"
    title="Criar agrupamento"
    @save="save()"
  >
    <produto-group-content
      :payload="payload"
    />
  </product-base-modal>
</template>

<script>
import NotificationMixin from '@/app/arch/mixins/NotificationMixin';
import ProdutoGroupContent from '../../../groups/ProdutoGroupContent.vue';
import ProdutoGroupRequest from '../../../groups/ProdutoGroupRequest';
import ProductBaseModal from './ProductBaseModal.vue';

export default {
  name: 'CreateGroupModal',
  components: { ProdutoGroupContent, ProductBaseModal },
  mixins: [NotificationMixin],
  data: () => ({
    requestGroup: ProdutoGroupRequest,
    payload: {
      descricao: '',
      nomProdutoAgrupamento: '',
      ordemExibicao: '',
    },
    loading: null,
  }),
  methods: {
    save() {
      this.loading = true;
      this.requestGroup.save(this.payload)
        .then(({ data }) => {
          this.$emit('success', data);
          this.success();
        })
        .catch(({ response }) => {
          this.showMessageError(response.data.message);
        }).finally(() => {
          this.loading = false;
        });
    },
    success() {
      this.showSuccessToast({
        text: 'Agrupamento criado',
      });
      this.dialog = false;
    },
    showMessageError(message) {
      this.showErrorToast({
        text: message || 'Falha ao criar agrupador',
      });
    },
  },
};
</script>
